// Shared route data — extracted from BeginnerPath/FortyDay pages so it can be
// imported by Node-side scripts (sitemap, prerender) that can't load JSX.

export const beginnerDays = [
  { d: 1, title: "The Two Origins of Breath", family: "breath", techniqueId: 1 },
  { d: 2, title: "AUM Fading Into Void", family: "sound", techniqueId: 16 },
  { d: 3, title: "The Bowl Without Partitions", family: "space", techniqueId: 36 },
  { d: 4, title: "Vast Open Place", family: "space", techniqueId: 37 },
  { d: 5, title: "Joy in Eating and Drinking", family: "daily", techniqueId: 49 },
  { d: 6, title: "Heightened Sense Awareness", family: "daily", techniqueId: 94 },
  { d: 7, title: "Between Two Thoughts", family: "space", techniqueId: 38 },
];

export const fortyDayPlan = [
  { d: 1, title: "The Two Origins of Breath", family: "Breath Doorway", techniqueId: 1 },
  { d: 2, title: "The Turning of Breath", family: "Breath Doorway", techniqueId: 2 },
  { d: 3, title: "The Center Beyond Breath", family: "Breath Doorway", techniqueId: 3 },
  { d: 4, title: "River Sound and Inner Sound", family: "Sound Doorway", techniqueId: 15 },
  { d: 5, title: "AUM Fading Into Void", family: "Sound Doorway", techniqueId: 16 },
  { d: 6, title: "The Void Around Any Sound", family: "Sound Doorway", techniqueId: 17 },
  { d: 7, title: "The Fading Edge of Music", family: "Sound Doorway", techniqueId: 18 },
  { d: 8, title: "Body Pervaded by Space", family: "Space Doorway", techniqueId: 20 },
  { d: 9, title: "One Body Part as Void", family: "Body Doorway", techniqueId: 23 },
  { d: 10, title: "Body Elements as Empty Space", family: "Body Doorway", techniqueId: 24 },
  { d: 11, title: "Where the Inhale Ends Inside", family: "Breath Doorway", techniqueId: 27 },
  { d: 12, title: "Daylong Gap Between Breaths", family: "Daily Doorway", techniqueId: 28 },
  { d: 13, title: "Slow Breath With Sound", family: "Breath Doorway", techniqueId: 32 },
  { d: 14, title: "The Bowl Without Partitions", family: "Space Doorway", techniqueId: 36 },
  { d: 15, title: "Vast Open Place", family: "Space Doorway", techniqueId: 37 },
  { d: 16, title: "Between Two Thoughts", family: "Space Doorway", techniqueId: 38 },
  { d: 17, title: "After One Thought, Before the Next", family: "Space Doorway", techniqueId: 39 },
  { d: 18, title: "The Meeting Points of Breath", family: "Breath Doorway", techniqueId: 41 },
  { d: 19, title: "Body or World Full of Bliss", family: "Emotion Doorway", techniqueId: 42 },
  { d: 20, title: "Joy of Reunion", family: "Love Doorway", techniqueId: 48 },
  { d: 21, title: "Joy in Eating and Drinking", family: "Daily Doorway", techniqueId: 49 },
  { d: 22, title: "Joy in Singing and Senses", family: "Sound Doorway", techniqueId: 50 },
  { d: 23, title: "Where the Mind Finds Satisfaction", family: "Daily Doorway", techniqueId: 51 },
  { d: 24, title: "The Threshold of Sleep", family: "Sleep Doorway", techniqueId: 52 },
  { d: 25, title: "Colors at the Edge of Light", family: "Space Doorway", techniqueId: 53 },
  { d: 26, title: "Rhythmic Movement", family: "Daily Doorway", techniqueId: 60 },
  { d: 27, title: "Clear Sky Gazing", family: "Space Doorway", techniqueId: 61 },
  { d: 28, title: "Inner Darkness With Eyes Closed", family: "Space Doorway", techniqueId: 65 },
  { d: 29, title: "Restraining a Sense Door", family: "Body Doorway", techniqueId: 66 },
  { d: 30, title: "The Vowel A", family: "Sound Doorway", techniqueId: 67 },
  { d: 31, title: "The End of Ha", family: "Sound Doorway", techniqueId: 68 },
  { d: 32, title: "Self as Unlimited Sky", family: "Space Doorway", techniqueId: 69 },
  { d: 33, title: "End Desire at Its Rising", family: "Daily Doorway", techniqueId: 73 },
  { d: 34, title: "Strong Emotion, Stop the Mind", family: "Emotion Doorway", techniqueId: 78 },
  { d: 35, title: "World as Magic Picture", family: "Space Doorway", techniqueId: 79 },
  { d: 36, title: "Between Pleasure and Pain", family: "Emotion Doorway", techniqueId: 80 },
  { d: 37, title: "Wherever Mind Goes Is Shiva", family: "Daily Doorway", techniqueId: 93 },
  { d: 38, title: "Heightened Sense Awareness", family: "Daily Doorway", techniqueId: 94 },
  { d: 39, title: "Devotion and Detachment", family: "Love Doorway", techniqueId: 98 },
  { d: 40, title: "No Bondage, No Liberation", family: "Space Doorway", techniqueId: 112 },
];
